<div>
  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item" role="presentation">
      <button
        class="nav-link active"
        id="pending-tab"
        data-toggle="tab"
        data-target="#pending"
        type="button"
        role="tab"
        aria-controls="pending"
        aria-selected="true"
        (click)="incubatorCheck('0')"
      >
        Pending
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button
        class="nav-link"
        id="approval-tab"
        data-toggle="tab"
        data-target="#approval"
        type="button"
        role="tab"
        aria-controls="approval"
        aria-selected="false"
        (click)="incubatorCheck('1')"
      >
        Approved
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button
        class="nav-link"
        id="rejected-tab"
        data-toggle="tab"
        data-target="#rejected"
        type="button"
        role="tab"
        aria-controls="rejected"
        aria-selected="false"
        (click)="incubatorCheck('-1')"
      >
        Rejected
      </button>
    </li>
  </ul>
  <div class="tab-content" id="myTabContent">
    <div
      class="tab-pane fade show active"
      id="pending"
      role="tabpanel"
      aria-labelledby="pending-tab"
    >
      <div *ngIf="noData == false">
        <div class="download-div">
          <button
            mat-raised-button
            color="accent"
            (click)="downloadExcel('Pending', 0)"
          >
            Export <i class="far fa-file-excel"></i>
          </button>
        </div>
        <div class="table-responsives">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns; let i = index"
            ></tr>
            <ng-container matColumnDef="index">
              <th mat-header-cell *matHeaderCellDef>No</th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorName">
              <th mat-header-cell *matHeaderCellDef>Corporate Name</th>
              <td mat-cell *matCellDef="let element">
                {{ element.incubatorName }}
              </td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Corporate Email Id</th>
              <td mat-cell *matCellDef="let element">{{ element.email }}</td>
            </ng-container>
            <ng-container matColumnDef="phone">
              <th mat-header-cell *matHeaderCellDef>Corporate Phone Number</th>
              <td mat-cell *matCellDef="let element">{{ element.phone }}</td>
            </ng-container>
            <ng-container matColumnDef="uniqueId">
              <th
                mat-header-cell
                *matHeaderCellDef
                [ngClass]="{ 'd-none': status == '0' }"
              >
                Corporate ID
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="center-cell"
                [ngClass]="{ 'd-none': status == '0' }"
              >
                <span>{{ element.uniqueId ? element.uniqueId : "-" }} </span>
                <span *ngIf="element.uniqueId === 'Other'"
                  >- {{ element.uniqueId }}</span
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegDesc">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                View Description
              </th>
              <td mat-cell *matCellDef="let element" class="text-center c-blue">
                <ng-container *ngIf="element.incubatorRegDesc">
                  <ion-icon
                    name="eye-outline"
                    (click)="viewDescrptionBtn(element.incubatorRegDesc)"
                  ></ion-icon>
                </ng-container>
                <ng-container class="c-black" *ngIf="!element.incubatorRegDesc">
                  <span>-</span>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="reason">
              <th
                [ngClass]="{ 'd-none': status != '-1' }"
                mat-header-cell
                *matHeaderCellDef
              >
                Reason
              </th>
              <td
                [ngClass]="{ 'd-none': status != '-1' }"
                mat-cell
                *matCellDef="let element"
              >
                {{ element.reason }}
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                Action
              </th>
              <td class="text-center" mat-cell *matCellDef="let element">
                <span
                  class="approval-span"
                  (click)="approvalIncubator(element.userid)"
                  >Approve</span
                >
                <span class="reject-span" (click)="rejectReason(element.userid)"
                  >Reject</span
                >
              </td>
            </ng-container>
          </table>
        </div>
        <mat-paginator
          #paginator
          class="mat-elevation-z8"
          [length]="pageTotalCount"
          [pageSize]="pageSize"
          [pageSizeOptions]="[25, 50, 75, 100]"
          showFirstLastButtons
          (page)="getServerData($event)"
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </div>
      <div class="text-center no-data-div" *ngIf="noData == true">
        <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
        <h6>There are no Corporate pending for approval</h6>
      </div>
    </div>
    <div
      class="tab-pane fade"
      id="approval"
      role="tabpanel"
      aria-labelledby="approval-tab"
    >
      <div *ngIf="noData == false">
        <div class="download-div">
          <button
            mat-raised-button
            color="accent"
            (click)="downloadExcel('Approval', 1)"
          >
            Export <i class="far fa-file-excel"></i>
          </button>
        </div>
        <div class="table-responsives">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns; let i = index"
            ></tr>
            <ng-container matColumnDef="index">
              <th mat-header-cell *matHeaderCellDef>No</th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorName">
              <th mat-header-cell *matHeaderCellDef>Corporate Name</th>
              <td mat-cell *matCellDef="let element">
                {{ element.incubatorName }}
              </td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Corporate Email Id</th>
              <td mat-cell *matCellDef="let element">{{ element.email }}</td>
            </ng-container>
            <ng-container matColumnDef="phone">
              <th mat-header-cell *matHeaderCellDef>Corporate Phone Number</th>
              <td mat-cell *matCellDef="let element">{{ element.phone }}</td>
            </ng-container>
            <ng-container matColumnDef="uniqueId">
              <th mat-header-cell *matHeaderCellDef>Corporate ID</th>
              <td mat-cell *matCellDef="let element" class="center-cell">
                <span>{{ element.uniqueId ? element.uniqueId : "-" }} </span>
                <span *ngIf="element.uniqueId === 'Other'"
                  >- {{ element.uniqueId }}</span
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegDesc">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                View Description
              </th>
              <td mat-cell *matCellDef="let element" class="text-center c-blue">
                <ng-container *ngIf="element.incubatorRegDesc">
                  <ion-icon
                    name="eye-outline"
                    (click)="viewDescrptionBtn(element.incubatorRegDesc)"
                  ></ion-icon>
                </ng-container>
                <ng-container class="c-black" *ngIf="!element.incubatorRegDesc">
                  <span>-</span>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorStatusUpdatedDate">
              <th mat-header-cell *matHeaderCellDef>Approved Date</th>
              <td mat-cell *matCellDef="let element" class="center-cell">
                <span
                  >{{
                    element.incubatorStatusUpdatedDate
                      ? element.incubatorStatusUpdatedDate
                      : "-"
                  }}
                </span>
                <span *ngIf="element.incubatorStatusUpdatedDate === 'Other'"
                  >- {{ element.incubatorStatusUpdatedDate }}</span
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="reason">
              <th
                [ngClass]="{ 'd-none': status != '-1' }"
                mat-header-cell
                *matHeaderCellDef
              >
                Reason
              </th>
              <td
                [ngClass]="{ 'd-none': status != '-1' }"
                mat-cell
                *matCellDef="let element"
              >
                {{ element.reason }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegistrationType">
              <th mat-header-cell *matHeaderCellDef>Registration Type</th>
              <td mat-cell *matCellDef="let element" class="center-cell">
                <span
                  >{{
                    element.incubatorRegistrationType
                      ? element.incubatorRegistrationType
                      : "-"
                  }}
                </span>
                <span *ngIf="element.incubatorRegistrationType === 'Other'"
                  >- {{ element.incubatorRegistrationTypeOther }}</span
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegFileName">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                View Document
              </th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <ng-container *ngIf="element.incubatorRegFileName">
                  <a href="{{ element.incubatorRegFileName }}" target="_blank">
                    <ion-icon name="document-attach-outline"></ion-icon>
                  </a>
                </ng-container>
                <ng-container *ngIf="!element.incubatorRegFileName">
                  <span>-</span>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th
                [ngClass]="{ 'd-none': status != '-1' }"
                class="text-center"
                mat-header-cell
                *matHeaderCellDef
              >
                Action
              </th>
              <td
                [ngClass]="{ 'd-none': status != '-1' }"
                class="text-center"
                mat-cell
                *matCellDef="let element"
              ></td>
            </ng-container>
          </table>
        </div>
        <mat-paginator
          #paginator
          class="mat-elevation-z8"
          [length]="pageTotalCount"
          [pageSize]="pageSize"
          [pageSizeOptions]="[25, 50, 75, 100]"
          showFirstLastButtons
          (page)="getServerData($event)"
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </div>
      <div class="text-center no-data-div" *ngIf="noData == true">
        <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
        <h6>There are no approved corporates</h6>
      </div>
    </div>
    <div
      class="tab-pane fade"
      id="rejected"
      role="tabpanel"
      aria-labelledby="rejected-tab"
    >
      <div *ngIf="noData == false">
        <div class="download-div">
          <button
            mat-raised-button
            color="accent"
            (click)="downloadExcel('Rejected', -1)"
          >
            Export <i class="far fa-file-excel"></i>
          </button>
        </div>
        <div class="table-responsives">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns; let i = index"
            ></tr>
            <ng-container matColumnDef="index">
              <th mat-header-cell *matHeaderCellDef>No</th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorName">
              <th mat-header-cell *matHeaderCellDef>Corporate Name</th>
              <td mat-cell *matCellDef="let element">
                {{ element.incubatorName }}
              </td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Corporate Email Id</th>
              <td mat-cell *matCellDef="let element">{{ element.email }}</td>
            </ng-container>
            <ng-container matColumnDef="phone">
              <th mat-header-cell *matHeaderCellDef>Corporate Phone Number</th>
              <td mat-cell *matCellDef="let element">{{ element.phone }}</td>
            </ng-container>
            <ng-container matColumnDef="incubatorStatusUpdatedDate">
              <th mat-header-cell *matHeaderCellDef>Rejected Date</th>
              <td mat-cell *matCellDef="let element" class="center-cell">
                <span
                  >{{
                    element.incubatorStatusUpdatedDate
                      ? element.incubatorStatusUpdatedDate
                      : "-"
                  }}
                </span>
                <span *ngIf="element.incubatorStatusUpdatedDate === 'Other'"
                  >- {{ element.incubatorStatusUpdatedDate }}</span
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="reason">
              <th mat-header-cell *matHeaderCellDef class="text-center">
                Reason
              </th>

              <td mat-cell *matCellDef="let element" class="text-center c-blue">
                <ng-container *ngIf="element.reason">
                  <ion-icon
                    name="eye-outline"
                    (click)="viewDescrptionBtn(element.reason, 'View Reason')"
                  ></ion-icon>
                </ng-container>
                <ng-container class="c-black" *ngIf="!element.reason">
                  <span>-</span>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegistrationType">
              <th mat-header-cell *matHeaderCellDef>Registration Type</th>
              <td mat-cell *matCellDef="let element" class="center-cell">
                <span
                  >{{
                    element.incubatorRegistrationType
                      ? element.incubatorRegistrationType
                      : "-"
                  }}
                </span>
                <span *ngIf="element.incubatorRegistrationType === 'Other'"
                  >- {{ element.incubatorRegistrationTypeOther }}</span
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegFileName">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                View Document
              </th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <a href="{{ element.incubatorRegFileName }}" target="_blank"
                  ><ion-icon name="document-attach-outline"></ion-icon
                ></a>
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                Action
              </th>
              <td class="text-center" mat-cell *matCellDef="let element">
                <mat-icon class="delete-i" (click)="deleteList(element.userid)">
                  delete</mat-icon
                >
              </td>
            </ng-container>
          </table>
        </div>
        <mat-paginator
          #paginator
          class="mat-elevation-z8"
          [length]="pageTotalCount"
          [pageSize]="pageSize"
          [pageSizeOptions]="[25, 50, 75, 100]"
          showFirstLastButtons
          (page)="getServerData($event)"
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </div>
      <div class="text-center no-data-div" *ngIf="noData == true">
        <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
        <h6>There are no rejected corporates</h6>
      </div>
    </div>
  </div>
</div>
